<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M16.6667 6.66656H3.33333C2.8731 6.66656 2.5 7.03966 2.5 7.4999V9.16656C2.5 9.6268 2.8731 9.9999 3.33333 9.9999H16.6667C17.1269 9.9999 17.5 9.6268 17.5 9.16656V7.4999C17.5 7.03966 17.1269 6.66656 16.6667 6.66656Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 6.66656V17.4999"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.8333 10V15.8333C15.8333 16.2754 15.6578 16.6993 15.3452 17.0118C15.0326 17.3244 14.6087 17.5 14.1667 17.5H5.83335C5.39132 17.5 4.9674 17.3244 4.65483 17.0118C4.34227 16.6993 4.16668 16.2754 4.16668 15.8333V10"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M6.25001 6.66673C5.69748 6.66673 5.16757 6.44723 4.77687 6.05653C4.38617 5.66583 4.16668 5.13593 4.16668 4.58339C4.16668 4.03086 4.38617 3.50095 4.77687 3.11025C5.16757 2.71955 5.69748 2.50006 6.25001 2.50006C7.05392 2.48605 7.8417 2.87611 8.51063 3.61936C9.17955 4.36261 9.69858 5.42456 10 6.66673C10.3014 5.42456 10.8205 4.36261 11.4894 3.61936C12.1583 2.87611 12.9461 2.48605 13.75 2.50006C14.3025 2.50006 14.8325 2.71955 15.2232 3.11025C15.6139 3.50095 15.8333 4.03086 15.8333 4.58339C15.8333 5.13593 15.6139 5.66583 15.2232 6.05653C14.8325 6.44723 14.3025 6.66673 13.75 6.66673"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconPresent',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
